/* dcl-app.js — interactivity for the cloned D'Creme Lift landing page */
(function(){
  function $(s,r){return (r||document).querySelector(s);}
  function all(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}

  // Add to cart (AJAX -> /cart)
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-dcl-atc]'); if(!btn) return;
    e.preventDefault();
    var id=btn.getAttribute('data-variant-id');
    var valEl=$('[data-dcl-qty-val]'); var q=valEl?(parseInt(valEl.textContent,10)||1):1;
    var units=parseInt(btn.getAttribute('data-units'),10)||1;
    if(!id){window.location.href='/cart';return;}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:q*units}]})})
      .then(function(r){if(!r.ok)throw 0;return r.json();})
      .then(function(){window.location.href='/cart';})
      .catch(function(){window.location.href='/cart';});
  });

  // Quantity stepper
  document.addEventListener('click',function(e){
    var dec=e.target.closest('[data-dcl-qty-dec]'),inc=e.target.closest('[data-dcl-qty-inc]');
    if(!dec&&!inc)return; var v=$('[data-dcl-qty-val]'); if(!v)return;
    var n=parseInt(v.textContent,10)||1; n=inc?n+1:Math.max(1,n-1); v.textContent=n;
  });

  // Gallery thumbnail swap
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-dcl-thumb]'); if(!t)return;
    var wrap=t.closest('[data-dcl-gallery]'); if(!wrap)return;
    var src=t.getAttribute('data-src'); var main=$('[data-dcl-main] img',wrap);
    if(main&&src)main.src=src;
    all('[data-dcl-thumb]',wrap).forEach(function(x){x.classList.remove('is-active');}); t.classList.add('is-active');
  });

  // Bundle selector + pricing
  function applyBundle(b){
    var price=b.getAttribute('data-price')||'';
    var comp=b.getAttribute('data-compare')||'';
    var save=b.getAttribute('data-save')||'';
    var units=b.getAttribute('data-units')||'1';
    all('[data-dcl-price]').forEach(function(el){ if(price)el.textContent=price; });
    all('[data-dcl-compare]').forEach(function(el){ el.textContent=comp; el.style.display=comp?'':'none'; });
    all('[data-dcl-save]').forEach(function(el){ el.textContent=save; el.style.display=save?'':'none'; });
    all('[data-dcl-atc-total]').forEach(function(el){ if(price)el.textContent=price; });
    all('[data-dcl-atc]').forEach(function(el){ el.setAttribute('data-units',units); });
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-dcl-bundle]'); if(!b)return; var g=b.closest('[data-dcl-bundles]');
    all('[data-dcl-bundle]',g).forEach(function(x){x.classList.remove('is-active');}); b.classList.add('is-active');
    applyBundle(b);
  });
  var _ab=$('[data-dcl-bundle].is-active'); if(_ab)applyBundle(_ab);

  // Science tabs
  document.addEventListener('click',function(e){
    var tb=e.target.closest('[data-dcl-tab]'); if(!tb)return; var sec=tb.closest('[data-dcl-science]');
    var idx=tb.getAttribute('data-dcl-tab');
    all('[data-dcl-tab]',sec).forEach(function(x){x.classList.remove('is-active');}); tb.classList.add('is-active');
    all('[data-dcl-panel]',sec).forEach(function(p){p.style.display=(p.getAttribute('data-dcl-panel')===idx)?'block':'none';});
  });

  // Reviews carousel
  all('[data-dcl-carousel]').forEach(function(c){
    var track=$('[data-dcl-track]',c); if(!track)return; var n=all('[data-dcl-slide]',track).length; var i=0;
    function go(){track.style.transform='translateX(-'+(i*100)+'%)';}
    var p=$('[data-dcl-prev]',c),nx=$('[data-dcl-next]',c);
    if(p)p.addEventListener('click',function(){i=(i-1+n)%n;go();});
    if(nx)nx.addEventListener('click',function(){i=(i+1)%n;go();});
  });

  // Before/After slider
  all('[data-dcl-ba]').forEach(function(ba){
    var top=$('[data-dcl-ba-top]',ba),line=$('[data-dcl-ba-line]',ba),inv=$('[data-dcl-ba-inv]',ba); var drag=false;
    function set(x){var r=ba.getBoundingClientRect();var p=Math.max(0,Math.min(100,(x-r.left)/r.width*100));
      if(top)top.style.width=p+'%'; if(line)line.style.left=p+'%'; if(inv)inv.style.width=(10000/Math.max(0.001,p))+'%';}
    ba.addEventListener('pointerdown',function(e){drag=true;set(e.clientX);});
    ba.addEventListener('pointermove',function(e){if(drag)set(e.clientX);});
    window.addEventListener('pointerup',function(){drag=false;});
  });

  // Countdown timers
  all('[data-dcl-countdown]').forEach(function(cd){
    var end=new Date(cd.getAttribute('data-end')).getTime(); if(isNaN(end))end=Date.now()+3*864e5;
    function p(n){return String(n).padStart(2,'0');}
    function tick(){var d=Math.max(0,end-Date.now());
      var D=$('[data-dcl-cd-d]',cd),H=$('[data-dcl-cd-h]',cd),M=$('[data-dcl-cd-m]',cd),S=$('[data-dcl-cd-s]',cd);
      if(D)D.textContent=p(Math.floor(d/864e5)); if(H)H.textContent=p(Math.floor(d/36e5)%24);
      if(M)M.textContent=p(Math.floor(d/6e4)%60); if(S)S.textContent=p(Math.floor(d/1e3)%60);}
    tick(); setInterval(tick,1000);
  });

  // Impact counters
  all('[data-dcl-counter]').forEach(function(el){
    var target=parseFloat(el.getAttribute('data-target'))||0; var suffix=el.getAttribute('data-suffix')||''; var done=false;
    function run(){done=true; var dur=1600,t0=performance.now();
      function step(now){var pr=Math.min(1,(now-t0)/dur);var e=1-Math.pow(1-pr,3);
        el.textContent=Math.round(target*e).toLocaleString('en-US')+suffix; if(pr<1)requestAnimationFrame(step);}
      requestAnimationFrame(step);}
    if('IntersectionObserver' in window){var io=new IntersectionObserver(function(en){if(en[0].isIntersecting&&!done){run();io.disconnect();}},{threshold:.35}); io.observe(el);} else run();
  });

  // Sticky mobile bar
  var sticky=$('[data-dcl-sticky]'),hero=$('[data-dcl-hero]');
  if(sticky&&hero&&'IntersectionObserver' in window){
    new IntersectionObserver(function(en){sticky.classList.toggle('is-visible',!en[0].isIntersecting);}).observe(hero);
  }
})();
